<template>
  <div>
    <v-text-field
      v-model="search"
      class="mt-2"
      label="Buscar"
      append-icon="mdi-magnify"
    />

    <v-btn-toggle
      v-model="categoriasSelecionadas"
      color="primary"
      rounded
      multiple
    >
      <v-btn
        v-for="(tipo,i) in categoriasMedios"
        :key="i"
        small
        class="mb-4"
      >
        {{ tipo.text }}
      </v-btn>
    </v-btn-toggle>
    <v-skeleton-loader v-if="isLoading" type="table-thead, table-row@15" class="mx-2"></v-skeleton-loader>
    <v-data-table
      v-else
      v-model="mediosSelected"
      :headers="headers"
      fixed-header
      :items="mediosFiltrados"
      item-key="ID_MEDIO"
      :search="search"
      height="800px"
      :item-class="getRowColor"
      group-by="ID_INCENDIO"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      disable-pagination
      hide-default-footer
      @click:row="zoomMedio"
      :headers-length="6"
      style="white-space: normal"
    >
      <template #no-data>
        <p>Datos no disponibles.</p>
      </template>

      <template #[`item.MEDIO`]="{ item }">
        <span>{{ item.MEDIO.substr(0,15) + (item.MEDIO.length > 15 ? '.' : '') }}</span>
      </template>

      <template #[`item.ULT_POSICION`]="{ item }">
        <span>{{ item.ULT_POSICION ? item.ULT_POSICION.FECHA : '' | formatDate }}</span>
      </template>

      <template #[`item.ESTADO`]="{ item }">
        <span>{{ nombreEstado(item.ESTADO) }}</span>
      </template>

      <template #[`item.FECHA`]="{ item }">
        <span>{{ item.FECHA ? item.FECHA : item.FECHA_FINALIZADO | formatDate }}</span>
      </template>

      <template #[`item.ID_INCENDIO_ANTERIOR`]="{ item }">
        <span>{{ getIncendioLabel(item.ID_INCENDIO_ANTERIOR) }}</span>
      </template>

      <template #[`group.header`]="{ group, toggle, isOpen }">
        <td :colspan="headers.length" style="cursor: pointer;" @click="toggle">
          <v-btn :ref="group" x-small icon :style="getGroupHeaderStyle(group)">
            <v-icon v-if="!isOpen">mdi-plus</v-icon>
            <v-icon v-else>mdi-minus</v-icon>
          </v-btn>
          <span> {{ getIncendioLabel(group) }}</span>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import constants from '../../helpers/constants'
import * as ArcGIS from '../../helpers/ArcGIS'

export default {
  props: { show: Boolean },

  data: () => ({
    isValid: false,
    sortBy: 'ULT_POSICION',
    sortDesc: true,
    headers: [
      { text: 'Nombre', value: 'MEDIO', align: 'left', sortable: true, width: '30%' },
      { text: 'Tipo', value: 'TIPO', align: 'left', sortable: true },
      {
        text: 'Fecha ult. posición',
        value: 'ULT_POSICION',
        align: 'left',
        sortable: true,
        sort: (a, b) => {
          if (!a || !a.FECHA) return -1
          if (!b || !b.FECHA) return 1
          return new Date(a.FECHA) - new Date(b.FECHA)
        }
      },
      { text: 'Estado', value: 'ESTADO', align: 'left', sortable: true },
      {
        text: 'Fecha ult. estado',
        value: 'FECHA',
        align: 'left',
        sortable: true,
        sort: (a, b) => {
          if (!a) return -1
          if (!b) return 1
          return new Date(a) - new Date(b)
        }
      },
      { text: 'Ultimo incendio', value: 'ID_INCENDIO_ANTERIOR', align: 'left', sortable: true }
    ],
    search: '',
    categoriasMedios: [
      { text: 'Aéreos', value: 'Aéreo', align: 'left', sortable: true },
      { text: 'Terrestres', value: 'Terrestre', align: 'left', sortable: true },
      { text: 'Recursos', value: 'Recurso', align: 'left', sortable: true }
    ],
    fechaAviso: null,
    dateMin: null,
    mediosSelected: [],
    idSector: null,
    mediosOrder: [],
    mediosFiltrados: [],
    estadoMedios: [],
    categoriasSelecionadas: [0, 1, 2],
    fechaBaseDescanso: '2018/01/01 00:00',
    isLoading: true
  }),

  computed: {
    disableAdd() {
      return this.mediosSelected.length === 0 || !this.isValid
    },

    medios() {
      const medios = JSON.parse(JSON.stringify(this.$store.getters['medio/medios']))
      const incendiosByIdCached = this.$store.state.incendio.incendioById || {}
      /** TODO: Esta cosa super cutre se hace para tener la fecha de fin descanso mas tardia en DialogAddMedios */
      medios.forEach((m) => {
        let fechaDescanso = this.$date.parseDate(this.fechaBaseDescanso)
        const incIds = Object.keys(incendiosByIdCached)
        for (const id of incIds) {
          const inc = incendiosByIdCached[id]
          for (const sector of (inc?.SECTORES || [])) {
            for (const medioSector of (sector?.MEDIOS || [])) {
              if (medioSector.ID_MEDIO?.equalsIgnoreCase?.(m.ID_MEDIO) && medioSector.FECHA_FIN_DESCANSO) {
                const newFecha = this.$date.parseDate(medioSector.FECHA_FIN_DESCANSO, 'YYYY-MM-DDTHH:mm:ss.SSSZ')
                if (newFecha > fechaDescanso) fechaDescanso = newFecha
              }
            }
          }
        }
        if (fechaDescanso.format('YYYY/MM/DD HH:mm') !== this.fechaBaseDescanso) m.FECHA_FIN_DESCANSO = fechaDescanso
      })
      return medios
    },

    sectores() {
      let sectores = []

      if (this.incendio) {
        sectores = this.incendio.SECTORES
      }

      return sectores
    }
  },

  watch: {
    async show () {
      if (this.show) {
        await this.loadDetallesIncendios()
        this.fechaAviso = this.$date.currentDate()
        this.orderMedios()
        this.isLoading = false
      }
    },

    medios() {
      this.orderMedios()
      this.isLoading = false
    },

    categoriasSelecionadas() {
      this.mediosFiltrados = this.mediosOrder.filter((a) => {
        let valor = -1

        switch (a.CATEGORIA) {
          case 'Aéreo':
            valor = 0
            break
          case 'Terrestre':
            valor = 1
            break
          case 'Recurso':
            valor = 2
            break
        }

        return this.categoriasSelecionadas.includes(valor)
      })
    }
  },

  created() {
    this.estadoMedios = constants.estadosMedio
  },

  methods: {
    async loadDetallesIncendios() {
      const mediosAsignados = (this.$store.getters['medio/medios'] || [])
        .map(m => m.ID_INCENDIO)
        .filter(id => !!id)
      const unique = Array.from(new Set(mediosAsignados))
      const idsIncendiosCacheados = this.$store.state.incendio.incendioById || {}
      const idsIncendiosNoCacheados = unique.filter(id => !idsIncendiosCacheados[id])
      for (const id of idsIncendiosNoCacheados) {
        await this.$store.dispatch('incendio/fetchIncendioById', id)
      }
    },

    disabledPorFinDescanso(medio) {
      let disabled = false

      if (medio.FECHA_FIN_DESCANSO) {
        const now = this.$date.now()
        const fechaFinDescanso = this.$date.parseDate(medio.FECHA_FIN_DESCANSO)
        disabled = fechaFinDescanso > now
      }
      return disabled
    },

    getRowColor(medio) { // TODO: esto es muy cutre pero no se como hacerlo de otra forma
      let rowClass = ''
      switch (medio.ESTADO) {
        case 1:
          rowClass = 'medioAvisoResumen'
          break
        case 2:
          rowClass = 'medioLlegadaIncResumen'
          break
        case 3:
          rowClass = 'medioSalidaResumen'
          break
      }

      if (this.disabledPorFinDescanso(medio)) {
        rowClass = 'medioDescansoResumen'
      }

      return rowClass
    },

    getIncendioLabel(id) {
      if (!id) return 'Sin asignar'
      const incendio = this.$store.getters['incendio/getIncendioByID'](id)
      if (incendio) return incendio.MUNICIPIO || incendio.LOCALIDAD || incendio.NOMBRE || 'Incendio'
      return 'Sin asignar'
    },

    getGroupHeaderStyle(id) {
      let color = 'var(--v-primaryLight-base)'
      if (id) {
        const incendio = this.$store.getters['incendio/getIncendioByID'](id)
        const estado = incendio?.ESTADOS?.[0]?.TIPO_INCENDIO_ESTADO?.COLOR
        if (estado) color = estado
      }
      return { 'background-color': color }
    },

    orderMedios() {
      const mediosOrder = JSON.parse(JSON.stringify(this.medios))

      mediosOrder.sort((a, b) => {
        const aEstado = a.ESTADO
        const bEstado = b.ESTADO
        const aMedio = a.MEDIO.toUpperCase()
        const bMedio = b.MEDIO.toUpperCase()

        if (aEstado === bEstado) {
          return (aMedio < bMedio) ? -1 : (aMedio > bMedio) ? 1 : 0
        } else {
          return (aEstado < bEstado) ? -1 : 1
        }
      })

      this.mediosOrder = mediosOrder
      this.mediosFiltrados = mediosOrder
    },

    zoomMedio(value) {
      const medio = this.mediosOrder.find(x => x.ID_MEDIO === value.ID_MEDIO)
      if (medio && medio.ULT_POSICION) {
        const center = {
          target: [medio.ULT_POSICION.LONGITUD, medio.ULT_POSICION.LATITUD],
          zoom: 17
        }

        ArcGIS.setCenterMap(center)
      }
    },

    nombreEstado(estado) {
      switch (estado) {
        case 24:
          return 'Alarmado'

        case 7:
          return 'En camino'

        case 1:
          return 'En lugar'

        case 19:
          return 'Finalizado'
      }
      return ''
    }
  }
}
</script>

<style>
  .medioAvisoResumen {
    background-color: #8EB4E3 !important;
  }
  .medioLlegadaIncResumen {
    background-color: #F14D5A !important;
  }
  .medioSalidaResumen {
    background-color: #FFC000 !important;
  }
  .medioDescansoResumen {
    background-color: #AAAAAA !important;
  }

</style>
